import { render, staticRenderFns } from "./BlogEdit.vue?vue&type=template&id=657587f0"
import script from "./BlogEdit.vue?vue&type=script&lang=ts"
export * from "./BlogEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports